import { IRootState } from '../../../store'
import { ICustomFormsSignatureState } from '../store/customSignature.types'

export const getCustomSignaturesSelector = (state: IRootState): ICustomFormsSignatureState => state.customFormSignature
